import { ProxyMode } from '@/enums';
import {
  AnalysisTypeElasticity,
  ExecutionSettingsDTO,
  ExecutionSettingsEntity,
} from '@/types';

export function convertExecutionSettingsDTOtoEntity(
  dto: ExecutionSettingsDTO
): ExecutionSettingsEntity {
  return {
    ...dto,
    elasticAnalysisTypes: convertElasticAnalysisTypesDTOtoEntity(
      dto.elasticAnalysisTypes
    ),
  };
}

export function convertElasticAnalysisTypesDTOtoEntity(
  analysisTypes: AnalysisTypeElasticity[]
) {
  return (
    analysisTypes?.map(analysis => ({
      name: analysis.name,
      value: analysis.type,
      active: analysis.active,
    })) || []
  );
}

export function convertExecutionSettingsEntityToDTO(
  entity: ExecutionSettingsEntity
): ExecutionSettingsDTO {
  return entity.mode === ProxyMode.ELASTIC
    ? {
        fixedUrl: entity.fixedUrl,
        mode: entity.mode,
        imageId: entity.imageId,
        size: entity.size,
        elasticAnalysisTypes: convertElasticAnalysisTypesEntityToDTO(
          entity.elasticAnalysisTypes
        ),
      }
    : {
        mode: entity.mode,
        fixedUrl: entity.fixedUrl,
        imageId: null,
        size: null,
        elasticAnalysisTypes: convertElasticAnalysisTypesEntityToDTO(
          entity.elasticAnalysisTypes,
          true
        ),
      };
}

export function convertElasticAnalysisTypesEntityToDTO(
  analysisTypes: { name: string; value: string; active: boolean }[],
  reset: boolean = false
) {
  return (
    analysisTypes?.map(analysis => ({
      name: analysis.name,
      type: analysis.value,
      active: reset ? false : analysis.active,
    })) || []
  );
}
